import BrowserCheck  from '../../core/lib/BrowserCheck';
import Designer from './Designer';
import Gallery from './Gallery';
import NotSupported from './NotSupported';
import template from './templates/main-container.tmpl';
import helpInfoTemplate from './templates/help-info.tmpl';
import localize from "../../core/localize";
import { DESIGNER } from '../../core/constants';
import AppSettings from "../../core/AppSettings";


class MainContainer {
	constructor (parentElement) {
		this.renderedTemplate = template;
		this.parentElement = parentElement;

		// Unique and will be designer specific
		AppSettings.activeDesigner = DESIGNER.METAL;

		this.designer = {};
		
	}

	// show main container
	show() {
		this.parentElement.innerHTML = this.renderedTemplate;

		// help info content template rendering
		this.parentElement.insertAdjacentHTML("beforeend", helpInfoTemplate);
		this.el = this.parentElement.querySelector('.main-container');

		// for language data 
		this.helpPage = this.parentElement.querySelector('.help-page');

		// language supports for all the parent elements
		localize(this.parentElement, AppSettings.Language);

		if (new BrowserCheck().isVersionSupported({ios: 9, android: 4.4, ie: 11}) !== true) {
			new NotSupported(this.el);

		} else {
			// show designer page
			this.designer = new Designer(this.el, {
				onShowGallery: () => this.showGallery()
			});
			//this.designer.show();

		}


	}



	showGallery() {
		this.designer.hide();
		 const gallery = new Gallery(this.el);
	}

	hide() {

	}
}

export default MainContainer;